<!--每个页面的卡片组件，具体样式在各个页面书写，公共样式仅设置了字体样式-->
<template>
    <div id="my-card">
      <div class="logoContent">
        <img class="logo" :src="logo"/>
      </div>
      <div class="textContent">
        <div class="title">{{this.title}}</div>
        <div class="text">{{this.text}}</div>
      </div>
    </div>
</template>

<script>
    export default {
      name: "my-card",
      data(){
          return{
            logo: undefined,
            title: String,
            text: String,
          }
      },
      props:{
        cardLogo: String,
        cardTitle: String,
        cardText: String,
      },
      watch:{
        cardLogo:{
          handler(newString,oldString){
            this.logo = require('@/'+this.cardLogo);
          }
        }
      },
      mounted() {
        this.logo = require('@/'+this.cardLogo);
        this.title = this.cardTitle;
        this.text = this.cardText;
      },
    }
</script>

<style lang="scss" scoped>
  .textContent {
    .title {
      font-size: 20px;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      font-weight: bold;
      color: #444444;
      line-height: 30px;
    }
    .text{
      text-align: left;
      font-size: 18px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #666666;
      line-height: 25px;
    }
  }


</style>
